"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTR = function FlagTR(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.78-12,20.85,2.46,38.13-3.32a1.06,1.06,0,0,1,1.21,1.6L29,13.29,39.84,27.94a1.06,1.06,0,0,1-1.16,1.65L21.21,24.38,10.63,39.21a1.06,1.06,0,0,1-1.92-.58L8.26,20.41-9.12,14.93a1.07,1.07,0,0,1,0-2L8,6.86,7.87-11.36A1.07,1.07,0,0,1,9.78-12Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-51.43,68.71a56.53,56.53,0,0,1-56.51-56.53A56.56,56.56,0,0,1-51.43-44.35a55.4,55.4,0,0,1,31.22,9.61,1.37,1.37,0,0,0,1.78-2.06A70,70,0,0,0-71.54-58.4c-35.94,1.23-65.7,30-68,65.93A70.63,70.63,0,0,0-69.09,82.8,70.06,70.06,0,0,0-18.38,61.11a1.36,1.36,0,0,0-1.78-2,55.42,55.42,0,0,1-31.27,9.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTR;
exports["default"] = _default;